import { render, staticRenderFns } from "./EditTaxi.vue?vue&type=template&id=56713f32&"
import script from "./EditTaxi.vue?vue&type=script&lang=js&"
export * from "./EditTaxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports